import { ReactNode } from "react";

import { Button, Typography } from "antd";
import { clsx } from "clsx";

import { RVIcon, RVIconSizeOptions } from "@regal-voice/ui";
import { ConstObjectValue } from "Types/shared";

import styles from "./PanelTitle.module.scss";

export const PanelTitleIcons = {
    RIGHT_ARROW: "arrow-right",
    LEFT_ARROW: "arrow-left",
} as const;
export type PanelTitleIconsType = ConstObjectValue<typeof PanelTitleIcons>;

export function PanelTitle({
    children,
    onClick,
    icon = PanelTitleIcons.RIGHT_ARROW,
    className,
}: {
    children: ReactNode;
    onClick: () => void;
    icon?: PanelTitleIconsType;
    className?: string;
}): JSX.Element {
    return (
        <div className={clsx(styles.title, className, "flex-row align-center")}>
            <Button
                type="text"
                className={styles.iconButton}
                icon={<RVIcon className={styles.icon} icon={icon} size={RVIconSizeOptions.SMALL} color="gray-5" />}
                onClick={onClick}
            />
            <Typography.Title level={4}>{children}</Typography.Title>
        </div>
    );
}
